import { actions } from "./store.js";
import { NotificationContainer } from "./NotificationContainer.js";
const NotificationService = {
    info: actions.info,
    success: actions.success,
    warning: actions.warning,
    error: actions.error
};
export { NotificationContainer, NotificationService };
